import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBusinessUnits } from '../../api/business-units';

export const getBusinessUnitsAsync = createAsyncThunk(
  'businessUnits/getBusinessUnits',
  getBusinessUnits
);

export interface BusinessUnit {
  id: number;
  name: string;
}

interface BusinessUnitState {
  data: BusinessUnit[];
}

const initialState: BusinessUnitState = {
  data: []
};

export default createSlice({
  name: 'businessUnits',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBusinessUnitsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
  }
});
